import { client } from '../../..'
import {
  ADD_HR_ROLE_TO_EMPLOYEE,
  REMOVE_HR_ROLE_FROM_EMPLOYEE,
  ADD_DOWNLOADER_ROLE_TO_EMPLOYEE,
  REMOVE_DOWNLOADER_ROLE_FROM_EMPLOYEE,
} from '../Mutations'
import { EMPLOYEES_WITH_HR_OR_DOWNLOADER_ROLE } from '../../employee/Queries'
import {
  Country,
  AddHrRoleToEmployeeMutationVariables,
  AddHrRoleToEmployeeMutation,
  RemoveHrRoleFromEmployeeMutation,
  RemoveHrRoleFromEmployeeMutationVariables,
  AddDownloaderRoleToEmployeeMutation,
  AddDownloaderRoleToEmployeeMutationVariables,
  RemoveDownloaderRoleFromEmployeeMutation,
  RemoveDownloaderRoleFromEmployeeMutationVariables,
} from '../../../types'
import { GraphQLFormattedError } from 'graphql'

const addHrRoleToEmployee = async (
  employeeId: number,
  selectedCountry: Country,
  roleType: 'admin' | 'readonly',
  hrVisibilityExcluded: boolean,
): Promise<{
  data: AddHrRoleToEmployeeMutation | null | undefined
  errors: readonly GraphQLFormattedError[] | undefined
}> => {
  const roleName = `HR_${roleType.toUpperCase()}_${selectedCountry.toUpperCase()}`

  const { data, errors } = await client.mutate<AddHrRoleToEmployeeMutation, AddHrRoleToEmployeeMutationVariables>({
    mutation: ADD_HR_ROLE_TO_EMPLOYEE,
    variables: {
      employeeId,
      roleName,
      hrVisibilityExcluded,
    },
    refetchQueries: [
      {
        query: EMPLOYEES_WITH_HR_OR_DOWNLOADER_ROLE,
      },
    ],
  })
  return { data, errors }
}

const removeHrRolesFromEmployee = async (
  employeeId: number,
  roleIds: number[],
  countryRoleName: string,
): Promise<{
  data: RemoveHrRoleFromEmployeeMutation | null | undefined
  errors: readonly GraphQLFormattedError[] | undefined
}> => {
  const { data, errors } = await client.mutate<RemoveHrRoleFromEmployeeMutation, RemoveHrRoleFromEmployeeMutationVariables>({
    mutation: REMOVE_HR_ROLE_FROM_EMPLOYEE,
    variables: {
      employeeId,
      roleIds,
      countryRoleName,
    },
    refetchQueries: [
      {
        query: EMPLOYEES_WITH_HR_OR_DOWNLOADER_ROLE,
      },
    ],
  })
  return { data, errors }
}

const removeDownloaderRoleFromEmployee = async (
  employeeId: number,
): Promise<{
  data: RemoveDownloaderRoleFromEmployeeMutation | null | undefined
  errors: readonly GraphQLFormattedError[] | undefined
}> => {
  const { data, errors } = await client.mutate<RemoveDownloaderRoleFromEmployeeMutation, RemoveDownloaderRoleFromEmployeeMutationVariables>(
    {
      mutation: REMOVE_DOWNLOADER_ROLE_FROM_EMPLOYEE,
      variables: {
        employeeId,
      },
      refetchQueries: [
        {
          query: EMPLOYEES_WITH_HR_OR_DOWNLOADER_ROLE,
        },
      ],
    },
  )
  return { data, errors }
}

const addDownloaderRoleToEmployee = async (
  employeeId: number,
): Promise<{
  data: AddDownloaderRoleToEmployeeMutation | null | undefined
  errors: readonly GraphQLFormattedError[] | undefined
}> => {
  const { data, errors } = await client.mutate<AddDownloaderRoleToEmployeeMutation, AddDownloaderRoleToEmployeeMutationVariables>({
    mutation: ADD_DOWNLOADER_ROLE_TO_EMPLOYEE,
    variables: {
      employeeId,
    },
    refetchQueries: [
      {
        query: EMPLOYEES_WITH_HR_OR_DOWNLOADER_ROLE,
      },
    ],
  })
  return { data, errors }
}

export { addHrRoleToEmployee, removeHrRolesFromEmployee, addDownloaderRoleToEmployee, removeDownloaderRoleFromEmployee }
